import { Clasification } from '../interfaces/treatment';

export class MClasification{
    public id: number = null;
    public name: string = null;

    constructor(clasification: Clasification){
        this.id = clasification.id
        this.name = clasification.nombre
    }
}